import React, { useState } from 'react';
import { Text, ViewStyle } from 'react-native';
import { KFlex, KImage } from '@kibt/meta-ui-krn';
import IconLiked from '@/assets/icon/icon_comment_list_liked.png';
import IconUnLiked from '@/assets/icon/icon_comment_list_unliked.png';
import { useSetState } from 'ahooks';
import { useHttp } from '@/request';
import { getQuery } from '@/common/const';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';
import { logClickCommentReviewsList } from './logger';
import { $k18n } from '@/common/i18n';

export interface LikeIconProps {
    liked: boolean;
    likeCount: number;
    commentId: number;
    videoList: any[];
    style?: ViewStyle;
}

const LikeIcon = ({ liked, likeCount, commentId, videoList, style }: LikeIconProps) => {
    const [likeInfo, setLikeInfo] = useSetState({
        liked,
        likeCount,
    });

    const itemId = getQuery('itemId');

    const { runAsync: postLikeComment } = useHttp('GET/rest/o/ecom/product/customer/comment/like', null, { manual: true });

    const handleLikeIconPress = () => {
        // console.log(likeInfo, 'handleLikeIconPress::::::');
        postLikeComment({
            query: {
                itemId,
                commentId: commentId,
                type: likeInfo.liked ? 0 : 1, // 0取消点赞1点赞
            },
        }).then(res => {
            console.log(res);
            setLikeInfo({
                liked: likeInfo.liked ? false : true,
                likeCount: likeInfo.liked ? likeInfo.likeCount - 1 : likeInfo.likeCount + 1,
            });
            logClickCommentReviewsList({
                comment: {
                    commentId,
                    videoList,
                },
                click_type: likeInfo.liked ? 'cancel' : 'like',
            });
        });
    };

    return (
        <KFlex style={[{ alignItems: 'center' }, style]} wait={200} onPress={handleLikeIconPress}>
            <KImage style={{"width":"3.381642512077295rem","height":"3.381642512077295rem","marginRight":"0.48309178743961356rem"}} source={likeInfo.liked ? IconLiked : IconUnLiked} />
            {/* TODO: 产品补充多语言 */}
            <Text style={{ fontSize: 12, color: likeInfo.liked ? 'rgba(255, 73, 6, 1)' : 'rgba(0, 0, 0, 0.4)' }}>
                {$k18n({ id: 'k_1309904', text: '有用' })}({likeInfo.likeCount})
            </Text>
        </KFlex>
    );
};

export default LikeIcon;
